import { translate } from '@thoughtspot/i18n';
import { Horizontal } from '@thoughtspot/radiant-react/widgets/layout';
import React from 'react';
import styles from '../../../styles/kpi.module.scss';
import { TEST_IDS } from './constants';
export const EmptyComparison = React.memo(function EmptyComparison() {
    return (React.createElement(Horizontal, { vAlignContent: "center", className: styles.comparisonEmpty, "data-testid": TEST_IDS.EMPTY_COMPARISON }, translate('kpi.comparisonPoint.unAvailable.label')));
});
//# sourceMappingURL=empty-comparison.js.map